document.addEventListener('DOMContentLoaded', () => {
  const buttonNext = document.querySelector('.slider-button--next');
  const buttonPrev = document.querySelector('.slider-button--prev');

  const tracking_container = document.querySelector('.slider-tracking');


  const updateNextDot = () => {
      console.log('Next')
      const active = tracking_container.querySelector('.current-count')
  
      let next = active.nextElementSibling;
  
      active.classList.remove(['current-count'])
      
      if (!next) {
        next = tracking_container.firstElementChild;
      }
  
      next.classList.add('current-count')    
  }

  const updatePrevDot = () => {
    console.log('Prev')

    const active = tracking_container.querySelector('.current-count');
    let prev = active.previousElementSibling;

    active.classList.remove(['current-count']);
    
    if (!prev) {
      prev = tracking_container.lastElementChild;
    }

    prev.classList.add('current-count');
  }


  buttonNext.addEventListener('click', updateNextDot);
  buttonPrev.addEventListener('click', updatePrevDot);
  
})